module.exports = __webpack_public_path__ + "static/media/img_image_466x445.9f172656.png";